import { Coordinates } from "../Util/Math/Coordinates"
import { KeyNoteRelationship } from "./KeyNoteRelationship"
import { MapDataParams } from "./MapData/MapData"
import { MapStore } from "./MapData/MapStore"
import NoteDisplayData from "./NoteDisplayData"
import {immerable} from "immer";
export class KeyPetal{
    [immerable] = true
    position:number // 1-based number
    label:string
    background:boolean
    static positionAngles:number[] = [-1,180,240,300,120,60,0,90] 
    constructor(position:number, label:string, background:boolean){
        this.position = position
        this.label = label
        this.background = background
    }
}
export class NoteData{
    [immerable] = true
    noteIndex:number
    x:number
    y:number
    tonic:number
    defined:boolean
    visible:boolean
    keyRadius:number
    onNoteClick:Function
    primaryLabel:string | null
    secondaryLabel:string | null
    keysRelationships:KeyNoteRelationship[] = []
    classNames:string[] = []
    noteDisplayData:NoteDisplayData
    keyPetals:KeyPetal[] = []

    static PositionTypeOdd:number = 1
    static PositionTypeEven:number = 0
    static PositionTypeSeven:number = 7
    static SelectedState_Default:number = 0
    static SelectedState_Selected:number = 1
    static SelectedState_Hilited:number = 2
    static ComparableProps = ['noteIndex', 'x', 'y', 'tonic', 'visible', 'primaryLabel', 'secondaryLabel', 'classNames', 'selectedState', 'defined']
    selectedState:number
    mapParams:MapDataParams

    constructor(mapParams:MapDataParams, noteIndex:number, x:number, y:number, 
                tonic:number, 
                onNoteClick:Function = ()=>{}, 
                noteDisplayData:NoteDisplayData){
        this.mapParams = mapParams
        this.noteIndex = noteIndex
        this.x = Math.floor(x)
        this.y = Math.floor(y)
        this.tonic = tonic
        this.keyRadius = mapParams.radius
        this.onNoteClick = onNoteClick
        this.visible = true
        this.selectedState = NoteData.SelectedState_Default
        this.defined = true
        this.primaryLabel = null
        this.secondaryLabel = null
        this.keysRelationships = []
        this.classNames = []
        this.noteDisplayData = noteDisplayData
    }

    static isEqual = (firstNote:NoteData, secondNote:NoteData) => {
        let equality:boolean = true
        if(firstNote.noteIndex !== secondNote.noteIndex){equality = false}
        if(firstNote.x !== secondNote.x){equality = false}
        if(firstNote.y !== secondNote.y){equality = false}
        if(firstNote.tonic !== secondNote.tonic){equality = false}
        if(firstNote.visible !== secondNote.visible){equality = false}
        if(firstNote.primaryLabel !== secondNote.primaryLabel){equality = false}
        if(firstNote.secondaryLabel !== secondNote.secondaryLabel){equality = false}
        if(firstNote.classNames !== secondNote.classNames){equality = false}
        if(firstNote.selectedState !== secondNote.selectedState){equality = false}
        if(firstNote.defined !== secondNote.defined){equality = false}
        return equality

    }
    getFontSize = () => {
        const circleRadius:number = this.noteDisplayData.noteRadiusToKeyRadius * this.keyRadius
        const circleDiameter:number = circleRadius * 2
        return Math.floor(circleDiameter * .6)
    }
    getCircleRadius = () => {
        let radius:number = this.keyRadius * this.noteDisplayData.noteRadiusToKeyRadius
        return Math.floor(radius)
    }
    setAsUpdated = () => {
    }
    setLabelToPosition = (dispatch:boolean = false) => {
        const position:string = String(this.keysRelationships[0].position + 1)
        this.setPrimaryLabel(position, dispatch)
    }
    setPrimaryLabel = (label:string|null, dispatch:boolean = false) => {
        if(this.primaryLabel !== label){
            this.primaryLabel = label
            this.setAsUpdated()
            return true
        }
        return false
    }
    addClasses = (add:boolean, classNames:string[], dispatch:boolean = false) => {
        const removeClass = (className:string) => {
            const i:number = this.classNames.indexOf(className)
            if(i >= 0){
                this.classNames.splice(i,1)
                return true
            }
            return false
        }
        const addClass = (className:string) => {
            const i:number = this.classNames.indexOf(className)
            if(i < 0){
                this.classNames.push(className)
                return true
            }
            return false
        }
        let didChange:boolean = false
        classNames.forEach((className:string)=>{
            if(add && !this.classNames.includes(className)){
                if(addClass(className)) didChange = true
            }
            else if(!add){
                if(removeClass(className)) didChange = true
            }
        })
        if(didChange){
            this.setAsUpdated()
        }
        return didChange
    }
    setVisibility = (visibility:boolean, dispatch:boolean = false) => {
        if(this.visible !== visibility){
            this.visible = visibility
            this.setAsUpdated()
            return true
        }
        return false
    }
    setDefined = (defined:boolean, dispatch:boolean = false) => {
        if(this.defined !== defined){
            this.defined = defined
            this.setAsUpdated()
            return true
        }
        return false
    }
    setSelectedState = (selectState:number, dispatch:boolean = false) => {
        if(this.selectedState !== selectState){
            this.selectedState = selectState
            this.setAsUpdated()
            return true
        }
        return false
    }
    nextSelectedState = (dispatch:boolean = false) => {
        const nextState:number = (this.selectedState + 1) % 3
        this.setSelectedState(nextState, dispatch)
    }
    hilite = (dispatch:boolean = false) => {
        if(this.selectedState !== NoteData.SelectedState_Hilited){
            this.selectedState = NoteData.SelectedState_Hilited
            this.setAsUpdated()
            return true
        }
        return false
    }
    isHilited = () => {
        return (this.selectedState === NoteData.SelectedState_Hilited)
    }

    isSelected = () => {
        return (this.selectedState === NoteData.SelectedState_Selected)
    }
    select = (dispatch:boolean = false) => {
        if(this.selectedState !== NoteData.SelectedState_Selected){
            this.selectedState = NoteData.SelectedState_Selected
            this.setAsUpdated()
            return true
        }
        return false
    }
    default = (dispatch:boolean = false) => {
        if(this.selectedState !== NoteData.SelectedState_Default){
            this.selectedState = NoteData.SelectedState_Default
            this.setAsUpdated()
            return true
        }
        return false
    }
    getRelationshipPositions = () => {
        const positions:number[] = this.keysRelationships.map((rel:KeyNoteRelationship)=>{
            return rel.position
        })
        return positions
    }
    getKeyRelationshipByPosition = (position:number) => {
        const keyRelationships:KeyNoteRelationship[] = this.keysRelationships.filter((keyRelationship:KeyNoteRelationship)=>{
            return(keyRelationship.position === position)
        })
        if(keyRelationships.length === 0){
            return undefined
        }
        return keyRelationships[0]
    }
    setKeyLabel = (position:number, label:string) => {
        const rel:KeyNoteRelationship|undefined = this.getKeyRelationshipByPosition(position)
        if(!rel){console.warn(`keynoterelationship was not found: position = ${position}, note = ${this.noteIndex}`)}
        if(rel && rel.label !== label){
            rel.label = label
            return true
        }
        return false
    }
    getCoordinatesAsArray = () => {
        return [this.x, this.y]
    }
    getCoordinates = () => {
        return new Coordinates(this.x, this.y)
    }
    getSelectedKeyPosition = () => {
        if(this.keysRelationships.length === 1){
           const relationship = this.keysRelationships[0]
           return relationship.position
        }
        for(let i:number = 0; i < this.keysRelationships.length; i++){
            const relationship:KeyNoteRelationship = this.keysRelationships[i]
            if(relationship.key.selected){
                return relationship.position
            }
        }
        if(this.keysRelationships.length === 2){
            return this.keysRelationships[0].position
        }
        return undefined
    }
    getPositionType = () => {
        if(this.isSeven()){
            return NoteData.PositionTypeSeven
        }
        return( (this.isOdd()) ? NoteData.PositionTypeOdd : NoteData.PositionTypeEven )
    }
    isOdd = () => {
        const position:number = this.keysRelationships[0].position
        if(this.isSeven()) return false
        const oddness:boolean = ((position % 2) === 0)// zerobased means evens are odd positions: 1,3,5.

        return (oddness) 
    }
    isSeven = () => {
        const position:number = this.keysRelationships[0].position
        return (position === 6)
    }
}